import { render, staticRenderFns } from "./ClicTab.vue?vue&type=template&id=49f4fa97&"
import script from "./ClicTab.vue?vue&type=script&lang=js&"
export * from "./ClicTab.vue?vue&type=script&lang=js&"
import style0 from "./ClicTab.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports